






















import Vue from 'vue';
import Component, {mixins} from 'vue-class-component';
import {Mixins, Prop, Ref} from "vue-property-decorator"
import JdhAttachedModalPopup from "@/design-system/shared/JdhAttachedModalPopup.vue"
import UniqueIdMixin from "@/design-system/utilities/UniqueIdMixin"
import {ActiveProvide} from "@/support/reactive"

/**
 * @status stable
 * @published 5.8.0
 * @changelog 5.8.0 Published.
 */
@Component({
    components: {JdhAttachedModalPopup}
})
export default class JdsReactionPanel extends mixins(UniqueIdMixin) {

    @ActiveProvide('jds.reaction-panel.bus') bus!: Vue
    @Ref() anchorEl!: HTMLElement
    open = false

    beforeMount() {
        this.bus = new Vue()
        this.bus.$on('close', () => {
            this.open = false
        })
    }

    togglePopup() {
        this.open = !this.open
    }
}
